import { LoadingState, RequestError } from '@components'

export function renderEmptyState(isRequesting?: boolean, error?: unknown, message?: string) {
  if (isRequesting) return <LoadingState message={message} />
  if (error) return <RequestError error={error} />
}
